import type { ClientQuestion, LocaleCode } from '@fixit/bozp-content';
import { resolveLocalized } from '../locale';

export interface MultiChoiceProps {
  question: Extract<ClientQuestion, { kind: 'multi' }>;
  value: string[] | undefined;
  onChange: (value: string[]) => void;
  locale: LocaleCode;
}

/** kind: 'multi' — emits a string[] of selected choice ids (order-insensitive server-side). */
export function MultiChoice({ question, value, onChange, locale }: MultiChoiceProps) {
  const selected = value ?? [];
  const toggle = (id: string) => {
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  };
  return (
    <fieldset data-quiz-kind="multi">
      <legend>{resolveLocalized(question.prompt, locale)}</legend>
      {(question.choices ?? []).map((choice) => {
        const label = resolveLocalized(choice.label, locale);
        return (
          <label key={choice.id}>
            <input
              type="checkbox"
              name={question.id}
              value={choice.id}
              checked={selected.includes(choice.id)}
              onChange={() => toggle(choice.id)}
            />
            {label}
          </label>
        );
      })}
    </fieldset>
  );
}
